<template>
  <CRow class="justify-content-center">
  <CCol>
    <CCard>
      <CForm @submit.prevent="save">
      <CCardHeader class="pb-4">
        <strong>Biên tập thông tin giao hàng</strong>
        <div class="card-header-actions">

          <CButton v-if="deliver.filename"
                   color="link" @click="downloadFile(deliver.filename)">
            {{deliver.filename}}
          </CButton>

          <CButton type="button" color="info" shape="pill" class="mr-2"
                   @click="save"
          >
            <CIcon name="cil-save"/>
            Lưu
          </CButton>

          <CButton v-if="deliverID" type="button" color="secondary" shape="pill" class="mr-2"
                   @click="refreshPage"
          >
            <CIcon name="cil-sync"/>
            Tải lại
          </CButton>

          <CButton v-if="getAllowDeleteButton" type="button" color="danger" shape="pill" class="mr-2"
                   @click="doDelete"
          >
            <CIcon name="cil-trash"/>
            Xóa
          </CButton>

          <CButton type="button" color="secondary" shape="pill" class="mr-2"
                   @click="goBack"
          >
            <CIcon name="cil-chevron-left"/>
            Quay lại
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>

        <CRow class="mb-2 font-weight-bold border-bottom pb-1">
          <CCol sm="3">Tên sản phẩm</CCol>
          <CCol sm="3">Tên bàn giao</CCol>
          <CCol sm="2">Số lượng</CCol>
          <CCol sm="3">Ghi chú</CCol>
          <CCol sm="1" class="text-right">
            <CButton color="info" shape="pill" size="sm" @click="openProductModal()">
              <CIcon name="cil-plus" class="mr-1"/>Thêm
            </CButton>
          </CCol>
        </CRow>

        <CRow v-for="(item, idx) in products_used" :key="idx" class="mb-1 py-1 border-bottom align-items-center product-row">
          <CCol sm="3">
            <span class="font-weight-bold">{{ item.product }}</span>
          </CCol>
          <CCol sm="3">
            <span>{{ item.alias || '-' }}</span>
          </CCol>
          <CCol sm="2">
            <span>{{ item.quantity }}</span>
          </CCol>
          <CCol sm="3">
            <span>{{ item.note || '-' }}</span>
          </CCol>
          <CCol sm="1" class="text-right">
            <CButton color="primary" size="lg" variant="ghost" @click="openProductModal(idx)" class="mr-1 p-1">
              <CIcon name="cil-pencil"/>
            </CButton>
            <CButton color="danger" size="lg" variant="ghost" @click="removeProduct(idx)" class="p-1">
              <CIcon name="cil-trash"/>
            </CButton>
          </CCol>
        </CRow>

        <CRow v-if="products_used.length === 0" class="mb-2">
          <CCol class="text-center text-muted py-2">
            <em>Chưa có sản phẩm nào. Nhấn nút "Thêm" để thêm sản phẩm.</em>
          </CCol>
        </CRow>

        <CSelect
          label="Lô sản xuất*:"
          placeholder="Dự án sản xuất"
          :options="project_names"
          @update:value="handleProjectNameUpdate"
          :value.sync="deliver.project"
          required
          horizontal
          :addLabelClasses="'text-right'"
          class="compact-input"
        />
          <CSelect
            label="Khách hàng*:"
            :options="name_list"
            @update:value="handleValueUpdate"
            :value.sync="deliver.customer"
            placeholder="Chọn khách hàng"
            required
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Công ty*:"
            type="text"
            v-model="deliver.company"
            placeholder="Tên công ty"
            required
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Địa chỉ công ty*:"
            type="text"
            v-model="deliver.address"
            placeholder="Địa chỉ công ty"
            required
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Biên bản bàn giao*:"
            placeholder="Biên bản giao hàng"
            type="text"
            v-model="deliver.bill"
            required
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Ngày giao*:"
            type="date"
            placeholder="Ngày giao"
            v-model="deliver.date"
            required
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Tên tệp bàn giao*:"
            type="text"
            placeholder="Tên tệp sau khi tạo"
            v-model="deliver.fn_prefix"
            horizontal
            required
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Tên người giao:"
            type="text"
            v-model="deliver.sender"
            placeholder="Tên người giao"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Chức vụ người giao:"
            type="text"
            v-model="deliver.sender_role"
            placeholder="Chức vụ người giao"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Số điện thoại người giao:"
            type="text"
            v-model="deliver.sender_phone"
            placeholder="Số người giao"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Tên người nhận:"
            type="text"
            placeholder="Tên người nhận"
            v-model="deliver.receiver"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Chức vụ người nhận:"
            type="text"
            placeholder="Chức vụ người nhận"
            v-model="deliver.receiver_role"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Số điện thoại người nhận:"
            type="text"
            placeholder="Số người nhận"
            v-model="deliver.receiver_phone"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CInput
            label="Địa điểm giao:"
            type="text"
            placeholder="Địa điểm giao nhận"
            v-model="deliver.location"
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <CSelect
            label="Loại:"
            :options="['Sản xuất mới', 'Trả bảo hành']"
            :value.sync="deliver.prod_type"
            placeholder="Kiểu hàng"
            required
            horizontal
            :addLabelClasses="'text-right'"
            class="compact-input"
          />
          <!-- <CTextarea
            label="Danh mục giao:"
            type="text"
            v-model="deliver.content"
            placeholder="Danh mục giao"
            horizontal
            rows="2"
            :addLabelClasses="'text-right'"
          />
          <CTextarea
            label="Ghi chú:"
            type="text"
            v-model="deliver.note"
            placeholder="Ghi chú"
            horizontal
            rows="4"
            :addLabelClasses="'text-right'"
          /> -->
      </CCardBody>
    </CForm>
    </CCard>

    <!-- Modal thêm/sửa sản phẩm -->
    <CModal
      :show.sync="showProductModal"
      :close-on-backdrop="false"
      color="info"
      size="lg"
    >
      <template #header>
        <h5 class="modal-title">{{ editingIndex !== null ? 'Chỉnh sửa sản phẩm' : 'Thêm sản phẩm mới' }}</h5>
        <CButtonClose @click="closeProductModal" class="text-white"/>
      </template>

      <CRow class="mb-2">
        <CCol sm="12">
          <CSelect
            label="Tên sản phẩm*:"
            :options="product_names"
            @update:value="handleProductNameUpdate"
            :value.sync="productName"
            placeholder="Chọn sản phẩm"
            :addLabelClasses="'text-right'"
            horizontal
          />
        </CCol>
      </CRow>
      <CRow class="mb-2">
        <CCol sm="12">
          <CInput
            label="Tên bàn giao:"
            placeholder="Nhập tên bàn giao"
            v-model="productAlias"
            :addLabelClasses="'text-right'"
            horizontal
          />
        </CCol>
      </CRow>
      <CRow class="mb-2">
        <CCol sm="12">
          <CInput
            label="Số lượng*:"
            type="number"
            placeholder="Nhập số lượng"
            v-model.number="productQuantity"
            :addLabelClasses="'text-right'"
            horizontal
            required
          />
        </CCol>
      </CRow>
      <CRow class="mb-2">
        <CCol sm="12">
          <CInput
            label="Ghi chú:"
            placeholder="Nhập ghi chú"
            v-model="productNote"
            :addLabelClasses="'text-right'"
            horizontal
          />
        </CCol>
      </CRow>

      <template #footer>
        <CButton color="secondary" @click="closeProductModal">
          <CIcon name="cil-x" class="mr-1"/>Hủy
        </CButton>
        <CButton color="info" @click="saveProduct">
          <CIcon name="cil-check" class="mr-1"/>{{ editingIndex !== null ? 'Cập nhật' : 'Thêm' }}
        </CButton>
      </template>
    </CModal>

  </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      allowDelete: true,
      deliverID: '',
      deliver: {
        product: '',
        project: '',
        bill: '',
        customer: '',
        company: '',
        address: '',
        date: '',
        location: '',
        note: '',
        sender: '',
        sender_role: '',
        sender_phone: '',
        receiver: '',
        receiver_role: '',
        receiver_phone: '',
        content: '',
        fn_prefix: '',
        filename: '',
        prod_type: 'Sản xuất mới'
      },
      products_used: [],
      product_names: [],
      project_names: [],
      customers: [],
      name_list: [],
      company: {
        name: '',
        company: '',
        address: '',
        receiver: '',
        role: '',
        phone: '',
      },
      guaranteeID: '',
      productName: '',
      productAlias: '',
      productQuantity: 0,
      productNote: '',
      showProductModal: false,
      editingIndex: null,
    };
  },
  created() {
    console.log(this.$route)
    this.deliverID = this.$route.query.id
    if (this.$route.query.bill) {
      this.deliverID = this.$route.query.bill
      console.log('request view deliver bill from guarantee ', this.deliverID)
    }
    this.refreshPage()
    this.guaranteeID = this.$route.query.guarantee_id
    if(this.guaranteeID) {
      this.deliver.customer = this.$route.query.customer
      this.deliver.quantity = this.$route.query.quantity
      this.deliver.product = this.$route.query.product
      this.deliver.project = this.$route.query.project
      this.productName = this.deliver.product
      this.productQuantity = this.deliver.quantity
      this.deliver.prod_type = 'Trả bảo hành'
    }
    this.getCustomers()

  },
  computed: {
    getAllowDeleteButton() {
      return (this.allowDelete && this.deliverID)
    }
  },
  watch: {
    'deliver.bill': function(newValue) {
      if (newValue) {
        // Chuyển đổi "/" thành "_" và loại bỏ khoảng trống
        this.deliver.fn_prefix = newValue
          .replace(/\//g, '_')  // Thay thế / bằng _
          .replace(/\s+/g, '')  // Loại bỏ tất cả khoảng trống
      }
    }
  },
  methods: {
    getCustomers() {
      this.$request('/api/device/customer').then(res => {
        this.customers = res.data.customers
        this.name_list = this.customers.slice(1).map(item => item.customer);
        this.name_list.push('Tạo mới')
        this.company = res.data.company
        this.deliver.sender = this.company.receiver
        this.deliver.sender_role = this.company.role
        this.deliver.sender_phone = this.company.phone
        // console.log(this.name_list)
        if(this.$route.query.customer) {
          this.deliver.customer = this.$route.query.customer
          this.handleValueUpdate(this.deliver.customer)
        }
      })

    },
    handleValueUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newCustomer()
      } else {
        const selectedItem = this.customers.find(item => item.customer === newValue);
        if (selectedItem) {
          this.deliver.location = selectedItem.company
          this.deliver.company = selectedItem.company;
          this.deliver.address = selectedItem.address;
          this.deliver.receiver = selectedItem.receiver;
          this.deliver.receiver_role = selectedItem.role;
          this.deliver.receiver_phone = selectedItem.phone;
        }
      }
    },
    canConvertToNumber(str) {
      return !isNaN(str);
    },
    refreshPage() {
      // console.log('deliverID', this.deliverID)
      let reqUrl = `/api/device/deliver/${this.deliverID}`
      if (!this.canConvertToNumber(this.deliverID)) {
        reqUrl = `/api/device/deliverbill?bill=${this.deliverID}`
      }
      // console.log('request url', reqUrl)
      this.$request.get(reqUrl).
      then(res=>{
        //console.log(res.data)
        if(res.data.product_names) {
          this.product_names = res.data.product_names;
        }
        this.product_names.push('Tạo mới')

        if(res.data.project_names) {
          this.project_names = res.data.project_names;
        }
        this.project_names.push('Tạo mới')

        if (res.data.status === 'success') {
          this.deliver = res.data.deliver
          this.products_used = res.data.products_used
          if (this.deliver.prod_type === '') {
            this.deliver.prod_type = 'Sản xuất mới'
          }
        }

        if(this.$route.query.project) {
          this.deliver.project = this.$route.query.project
        }
        if(this.$route.query.customer) {
          this.deliver.customer = this.$route.query.customer
          this.handleValueUpdate(this.deliver.customer)
        }

        if(this.$route.query.products) {
          //console.log(this.$route.query.products)
          if (Array.isArray(this.$route.query.products)) {
            this.product_names = this.$route.query.products
              .filter(item => item && item.product) // chỉ lấy object có field product
              .map(item => item.product)
            if(this.product_names.length > 0) {
              this.productName = this.product_names[0]
            }
          }
        }
      })
    },
    save() {
      // console.log('Lưu deliver: ', this.deliver)
      this.$swal.fire({
        title: "Lưu phiếu giao hàng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/deliver`,
            {
              deliver: this.deliver,
              products_used: this.products_used
            }).
          then(res => {
            if(res.data.status === 'success') {
              this.deliver = res.data.deliver;
              this.updateGuaranteeSendBill()
              this.$swal.fire({
                icon: "success",
                title: "Tạo/cập nhật phiếu giao hàng",
                html: "Tạo phiếu giao hàng: " + this.deliver.bill + " thành công",
              })
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.deliverID ? "Cập nhật phiếu giao hàng" : "Tạo phiếu giao hàng mới",
                html: "Tạo phiếu giao hàng " + this.deliver.bill +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    doDelete() {
      // console.log("Delete deliver bill:", this.deliver.bill);
      this.$swal.fire({
        title: "Xóa phiếu giao hàng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/device/deliver/${this.deliver.id}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa phiếu giao hàng",
                html: "Xóa phiếu giao hàng: " + this.deliver.bill + " thành công" ,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa phiếu giao hàng",
                html: "Xóa phiếu giao hàng: " + this.deliver.bill +
                  "<br> lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    newCustomer() {
      this.$router.push({
        path: '/device/cusedit',
      })
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/device/deliverdownload/${fileName}?id=${this.deliver.id}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    updateGuaranteeSendBill() {
      if(this.guaranteeID) {
        // console.log('update to guarantee: ', this.guaranteeID);
        this.$request.post(`/api/device/guaranteesend`,
          {
            id: Number(this.guaranteeID),
            bill:  this.deliver.bill,
          })
      }
    },
    handleProductNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newProduct()
      }
    },
    newProduct() {
      this.$router.push({
        path: '/device/prodedit',
      })
    },
    handleProjectNameUpdate(newValue) {
      if (newValue === 'Tạo mới') {
        this.newProject()
      }
    },
    newProject() {
      this.$router.push({
        path: '/project/mod',
      })
    },
    openProductModal(index = null) {
      this.editingIndex = index
      if (index !== null) {
        // Chế độ sửa
        const item = this.products_used[index]
        this.productName = item.product
        this.productAlias = item.alias
        this.productQuantity = item.quantity
        this.productNote = item.note
      } else {
        // Chế độ thêm mới
        this.productName = ''
        this.productAlias = ''
        this.productQuantity = 0
        this.productNote = ''
      }
      this.showProductModal = true
    },
    closeProductModal() {
      this.showProductModal = false
      this.editingIndex = null
      this.productName = ''
      this.productAlias = ''
      this.productQuantity = 0
      this.productNote = ''
    },
    saveProduct() {
      if (!this.productName || this.productQuantity <= 0) {
        this.$swal.fire({
          icon: "warning",
          title: "Thông báo",
          text: "Vui lòng chọn sản phẩm và nhập số lượng hợp lệ!",
        })
        return
      }

      if (!this.deliver.project || this.deliver.project === '') {
        this.$swal.fire({
          icon: "warning",
          title: "Thông báo",
          text: "Vui lòng chọn lô sản xuất trước!",
        })
        return
      }

      if (!Array.isArray(this.products_used)) {
        this.products_used = []
      }

      if (this.editingIndex !== null) {
        // Cập nhật sản phẩm đã có
        this.products_used[this.editingIndex] = {
          bill: this.deliver.bill,
          project: this.deliver.project,
          product: this.productName,
          alias: this.productAlias,
          note: this.productNote,
          quantity: this.productQuantity,
          prod_type: this.deliver.prod_type || 'Sản xuất mới'
        }
      } else {
        // Kiểm tra trùng lặp khi thêm mới
        const exists = this.products_used.some(
          (item) => item.product === this.productName
        )

        if (exists) {
          this.$swal.fire({
            icon: "warning",
            title: "Thông báo",
            text: "Sản phẩm này đã có trong danh sách!",
          })
          return
        }

        // Thêm sản phẩm mới
        this.products_used.push({
          bill: this.deliver.bill,
          project: this.deliver.project,
          product: this.productName,
          alias: this.productAlias,
          note: this.productNote,
          quantity: this.productQuantity,
          prod_type: this.deliver.prod_type || 'Sản xuất mới'
        })
      }

      this.closeProductModal()
    },
    removeProduct(index) {
      this.$swal.fire({
        title: "Xóa sản phẩm?",
        text: "Bạn có chắc muốn xóa sản phẩm này khỏi danh sách?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy"
      }).then((result) => {
        if (result.isConfirmed) {
          this.products_used.splice(index, 1)
        }
      })
    }
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #d8dbe0;
}

/* Giảm khoảng cách giữa các input xuống 80% */
.compact-input {
  margin-bottom: 0.6rem !important;
}

/* Giảm padding cho product rows */
.product-row {
  line-height: 1.3;
}

/* Giảm khoảng cách trong modal */
.modal-body .row {
  margin-bottom: 0.6rem;
}
</style>
